module.exports = __webpack_public_path__ + "static/media/1POLICY37.e91ee862.jpg";